import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SentLetter } from '../../models/sent-letter.interface';
import { Claim } from '../../models/claim.interface';

@Component({
  selector: 'app-email-details',
  templateUrl: './email-details.component.html',
  styleUrls: ['./email-details.component.scss']
})
export class EmailDetailsComponent implements OnInit {
  letter!: SentLetter;
  sentTo : string | null  = '';
  sentAt : string | null  = '';
  emailTitle : string | null  = '';
  emailContent : string | null  = '';
  claim : Claim | string | null = '' ;
  
  constructor(
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    this.letter = this.config?.data?.letter;
    this.setData();
  }

  setData() {
    this.sentTo = this.letter?.emails ?  this.letter?.emails.join(" , ") : '';
    this.sentAt = this.letter?.send_at ? this.letter?.send_at : '';
    this.emailTitle = this.letter?.letter_title ? this.letter?.letter_title  : '' ;
    this.emailContent = this.letter?.body ? this.letter?.body : '' ;
    this.claim = this.letter?.claim  ? this.letter?.claim?.claim_number : null ;
  }

  public close(payload?: any) {
    this.ref.close(payload);
  }

}
